import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/zdy_ws/',
  base: '/',
  routes: [
    {
      path: '/',
      name: '',
      meta:{
        title: '首页',
        keepAlive: true  //false不显示头部
      },
      component:()=>import('@/views/Home')
    },
    {
      path: '/home',
      name: '首页',
      meta:{
        title: '首页',
        keepAlive: true  //false不显示头部
      },
      component:()=>import('@/views/Home')
    },
    {
      path: '/login',
      name: '登录',
      meta:{
        title: '登录',
        keepAlive: false  //false不显示头部
      },
      component:()=>import('@/views/login')
    },
    {
      path: '/waiting',
      name: '',
      meta:{
        title: '敬请期待',
        keepAlive: true  
      },
      component:()=>import('@/views/waiting')
    },
    {
      path: '/trust',
      name: '业主委托',
      meta:{
        title: '业主委托',
        keepAlive: true  
      },
      component:()=>import('@/views/trust/index')
    },
    {
      path: '/about',
      name: '关于我们',
      meta:{
        title: '关于我们',
        keepAlive: true  
      },
      component:()=>import('@/views/about/index')
    },
    {
      path: '/shopping',
      name: '智鼎云商城',
      meta:{
        title: '智鼎云商城',
        keepAlive: true  
      },
      component:()=>import('@/views/shopping/index')
    },
    {
      path: '/agreement',
      name: '隐私协议',
      meta:{
        title: '隐私协议',
        keepAlive: true  
      },
      component:()=>import('@/views/agreement/index')
    },
    {
      path: '/explain',
      name: '隐私政策说明',
      meta:{
        title: '隐私政策说明',
        keepAlive: true  
      },
      component:()=>import('@/views/explain/explain')
    },
    { path: '*', component:()=>import('@/views/Home')}
  ]
})
